import { useTranslation } from 'react-i18next';

import { Button } from '~/components/Button';
import { Icon } from '~/components/Icon';
import { ModalDialog } from '~/components/ModalDialog/ModalDialog';

interface DeleteRowModalProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  platformName: string;
}

export function DeleteRowModal({
  isOpen,
  onOpenChange,
  onConfirm,
  platformName,
}: DeleteRowModalProps) {
  const { t } = useTranslation('campaign-planner');

  return (
    <ModalDialog open={isOpen} onOpenChange={onOpenChange}>
      <ModalDialog.Header>
        <Icon type="trash-can" variant="light" size="md" className="mr-sm" />
        {t('digitalCampaigns.mediaPlan.platforms.deleteRowModal.title')}
      </ModalDialog.Header>
      <ModalDialog.Body className="text-body-sm">
        {t('digitalCampaigns.mediaPlan.platforms.deleteRowModal.description', {
          platform: platformName,
        })}
      </ModalDialog.Body>
      <ModalDialog.Footer>
        <ModalDialog.Close>
          <Button variant="text" className="font-semibold">
            {t('digitalCampaigns.mediaPlan.platforms.deleteRowModal.cancel')}
          </Button>
        </ModalDialog.Close>
        <ModalDialog.Close>
          <Button variant="error" className="font-semibold" onClick={onConfirm}>
            {t('digitalCampaigns.mediaPlan.platforms.deleteRowModal.confirm')}
          </Button>
        </ModalDialog.Close>
      </ModalDialog.Footer>
    </ModalDialog>
  );
}

DeleteRowModal.displayName = 'DeleteRowModal';
